import styled from '@emotion/styled'

export const CardPlanEntitlementsStyle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.375rem; /* 6px */
  .checkbox-btn {
    width: 100%;
    margin: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: clamp(0.875rem, 0.8rem + 0.4vw, 1rem); /* 14px → 16px */
    line-height: clamp(1.25rem, 1.1rem + 0.5vw, 1.5rem); /* 20px → 24px */
    letter-spacing: 0;
    color: #121212;

    input {
      cursor: pointer;
    }
  }
  .checkbox-btn.disabled {
    cursor: not-allowed;
    color: #1212128f;
  }
`
